

























































































import { Result, SearchResponse } from '@empathybroker/tsclient-search';

import { createPopper } from '@popperjs/core';

import Sortable from 'sortablejs';

import { DeviceEnum } from '../../enums';

import { UiCheckbox, UiIconButton } from '../keen-ui';
import LoadingMask from '../loading-mask.component.vue';

export default {
  name: 'tags-input',
  components: {
    UiIconButton,
    UiCheckbox,
    LoadingMask
  },
  computed: {
    inputProps: function () {
      return {
        placeholder: (!this.disabled ? this.placeholder : ''),
        disabled: this.disabled
      };
    },
    inputHooks: function () {
      return {
        focus: () => this.focused = true,
        blur: () => this.focused = false
      };
    },
    searchResultsOptions: function () {
      let products: Result[] = [];
      if (!!this.searchProductsResponse) {
        products = this.searchProductsResponse.data.items.map((result: Result) => ({
          id: result.id,
          name: `${ result.id } - ${ result.name }`,
          image: result.imageUrl,
          selected: this.values.some(value => value.id === result.id)
        }));
      }
      return products;
    }
  },
  props: {
    values: {
      type: Array,
      default: () => []
    },
    maxValues: Number,
    help: String,
    placeholder: String,
    sortable: Boolean,
    searchable: Boolean,
    searchRequest: Function,
    searchProductsResponse: Object,
    searchProductIdsResponse: Array,
    clearable: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Object,
      default: () => ({
        search: false,
        searchIds: false
      })
    },
    disabled: Boolean
  },
  data: function () {
    return {
      value: '',
      queryChangeTimeout: undefined,
      focused: false,
      productIdsSeparator: ';',
      searchResultsOpened: false,
      popper: undefined,
      messages: this.$epb.messages.crud,
      DeviceEnum
    };
  },
  methods: {
    onSearchInputChange: function (): void {
      if (this.getProductIdsFromValue(this.value).length > 1) {
        this.pasteProductIds();
      } else {
        this.onDebounceQueryChange();
      }
    },
    getProductIdsFromValue: function (value: string): string[] {
      return value.split(this.productIdsSeparator).reduce((productIds: string[], productId: string) => {
        productId = productId.trim();
        if (!!productId) {
          productIds.push(productId);
        }
        return productIds;
      }, []);
    },
    onDebounceQueryChange: function (): void {
      clearTimeout(this.queryChangeTimeout);
      this.queryChangeTimeout = setTimeout(() => {
        this.onQueryChange(this.value);
      }, 300);
    },
    onQueryChange: function (query: string): void {
      this.$emit('queryChange', query);
      this.$refs.searchResultContainer.scrollTop = 0;
      this.searchResultsOpened = true;
    },
    pasteProductIds: function (): void {
      this.$emit('pasteIds', this.getProductIdsFromValue(this.value));
    },
    addValue: function (inputValues, updateValue = true): void {
      const isStringInput: boolean = this.isString(inputValues);
      const valuesToAdd: any[] = isStringInput ? inputValues.split(this.productIdsSeparator) : inputValues;
      const valuesToAddCopy: any[] = [...valuesToAdd];

      valuesToAdd.forEach((value: string) => {
        value = isStringInput ? value.trim() : value;
        if (!!value && (this.getIndexValue(value, isStringInput) < 0)
          && (!this.maxValues || this.values.length + 1 <= this.maxValues)) {
          this.values.push(value);
          valuesToAddCopy.splice(valuesToAddCopy.indexOf(value), 1);
          if (updateValue) {
            this.value = isStringInput ? valuesToAddCopy.join(this.productIdsSeparator) : valuesToAddCopy.map(val => val.id)
              .join(this.productIdsSeparator);
          }
        }
      });
    },
    onCheckboxChange: function (item, checked): void {
      if (checked) {
        this.addValue([item], false);
      } else {
        this.removeValue(item);
      }
    },
    removeValue: function (value): void {
      const indexValue = this.getIndexValue(value, this.isString(value));
      if (indexValue >= 0) {
        this.values.splice(indexValue, 1);
      }
    },
    clear: function (): void {
      this.$emit('update:values', []);
    },
    closeDropdown: function (evt): void {
      if (!this.$refs.searchResultContainer.contains(evt.target)
        && !this.$refs.valuesContainer.$el.contains(evt.target)
        && !this.$refs.actionsContainer.contains(evt.target)) {
        this.searchResultsOpened = false;
        this.value = '';
      }
    },
    isString: function (inputValue): boolean {
      return (typeof inputValue === 'string' || inputValue instanceof String);
    },
    getIndexValue(value, isString): number {
      if (isString) {
        return this.values.indexOf(value);
      } else {
        return this.values.findIndex((existingValue) => existingValue.id === value.id);
      }
    },
    cleanProductId: function (productId: string): string {
      return productId.trim().replace(/\//g, '');
    }
  },
  mounted: function (): void {
    document.addEventListener('click', this.closeDropdown);
    this.popper = createPopper(this.$refs.valuesContainer.$el, this.$refs.searchResultContainer,
      {
        modifiers: [
          {
            name: 'flip',
            options: {
              padding: { bottom: 50, top: 50 }
            }
          }
        ]
      });

    if (this.sortable) {
      Sortable.create(this.$refs.valuesContainer.$el, {
        handle: '.tags-input__value-handler',
        animation: 500,
        ghostClass: '.tags-input__value--ghost',
        draggable: '.tags-input__value',
        onUpdate: (ev) => {
          const movedValues = this.values.splice(ev.oldIndex, 1)[0];
          this.values.splice(ev.newIndex, 0, movedValues);
        }
      });
    }
  },
  beforeDestroy: function () {
    document.removeEventListener('click', this.closeDropdown);
  },
  watch: {
    searchProductIdsResponse: function () {
      const cleanedProductIds = this.getProductIdsFromValue(this.value).map(this.cleanProductId);
      const selectedOptions = [];
      this.searchProductIdsResponse.forEach((searchResponse: SearchResponse, index: number) => {
        if (!!searchResponse.data && !!searchResponse.data.items && !!searchResponse.data.items.length) {
          const result = searchResponse.data.items[0];
          const cleanedProductId = this.cleanProductId(result.id);
          if (cleanedProductId === cleanedProductIds[index]) {
            selectedOptions.push({
              id: result.id,
              name: `${ result.id } - ${ result.name }`,
              image: result.imageUrl
            });
          }
        }
      });
      this.addValue(selectedOptions);
    },
    values: function () {
      this.popper.update();
    }
  }
};
